module.exports = "<div class=\"full\">\n\t<section>\n  <router-outlet></router-outlet>\n \n</section>\n\n</div>\n"